function decodeJwtPayload(token) {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    // Base64url → Base64
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    // Base64 → UTF-8 JSON 字符串
    const jsonStr = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonStr);
  } catch (e) {
    return null;
  }
}

function getUserInf() {
  const authToken = sessionStorage.getItem('accessToken');
  if (authToken) {
    const payload = decodeJwtPayload(authToken);
    if (payload) {
      return {
        userId: payload.userId,
        loginName: payload.realName || payload.loginAccount || payload.sub || '',
        orgId: payload.orgId,
        roleId: payload.roleId,
        authToken: authToken,
      };
    }
  }
  return null;
}

const setUserInf = (token) => {
  sessionStorage.setItem('accessToken', token);
};

export { getUserInf, setUserInf };
